$(document).ready(function($) {
  var url = '';
  var tags = {
    size: '',
    entry: '',
  };
  var tagsArr = [];

  $('.hammock-finder-cta').colorbox({
    transition: 'fade',
    speed: '500',
    scrolling: false,
    fadeOut: '500',
    inline: true,
    width: '100%',
    height: '100%',
    onOpen: function() {
      $('.hammock-finder-container-1').show();
      $('.hammock-finder-container-2').hide();
    }
  });

  $('.your-size').click(function() {
    $('.hammock-finder-container-2').hide();
    $('.hammock-finder-container-1').show();
  });
  $('.hammock-finder-next, .entry-type').click(function() {
    $('.hammock-finder-container-1').hide();
    $('.hammock-finder-container-2').show();
  });

  $('input[name=hammock-finder-size]').click(function() {
    $('label.hammock-finder-size').removeClass('active');
    tags.size = $(this).val();
    $(this).next().addClass('active');
  });

  $('input[name=hammock-finder-entry]').click(function() {
    $('label.hammock-finder-entry').removeClass('active');
    tags.entry = $(this).val();
    $(this).next().addClass('active');
  });

  $('.hammock-finder-look').click(function() {
    $.each(tags, function(ind, val) {
      if (val) {
        tagsArr.push(val);
      }
    });
    url = '/collections/hammocks/' + tagsArr.join('+').concat('#filters');
    $(location).attr('href', url);
  });
});
